<template lang="pug">
.setor
  h3.titulo {{ titulo }}
  el-row(:gutter="12").pesquisa
    el-col(:lg="8", :md="9", :sm="24")
      p.label Selecionar período:
      //- A tag form esta sendo usada para desabilitar o autofill do browser
      form
        el-date-picker.full-width.input(
          v-bind="$attrs",
          type="daterange",
          unlink-panels,
          placeholder="Selecione",
          range-separator="a",
          format="dd/MM/yyyy",
          start-placeholder="Data inicial",
          end-placeholder="Data final",
          v-model="filtro.dateRange",
          name='prazo',
          :picker-options='options'
          :clearable="false"
        )
  el-row
    .button-pesquisar
      el-button.margin-button(type="text", @click="limparPesquisa")
        |  Limpar filtro
      el-button.margin-button(type="primary", @click="pesquisar")
        i.icon(class="fa fa-search")
        |  Pesquisar

  el-row(:gutter="10").margin
    div(v-if="hasDados")
      el-col.width-100(:sm="24")
        el-card(shadow="hover").box-card
          slot(name="header")
            h3 Produtividade dos setores
          div
            grafico-processo-por-setor(@produtividadePorSetor="produtividadePorSetor", :dadosLabels="produtividade.produtividadeSetores", :filtro="filtro")
    div.flex(v-else)
      .border-top-bottom
        span.cinza Não existem resultados para serem exibidos.

  .margin
    el-button.btn(
      type="default"
      @click="voltar()"
    )
      i.fa.fa-chevron-left
      | &nbsp Voltar

</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import GraficoProcessoPorSetor from '../../produtividade/components/GraficoProcessoPorSetor'

export default {

  components: {
    GraficoProcessoPorSetor
  },

  data () {
    return {
      filtro: {
        pagina: 0,
        analista: null,
        setor: null,
        dateRange: '',
        perfis: [],
        acoes: [],
        setores: [],
        municipios: [],
        dataInicio: null,
        dataFim: null
      },
      isLoading: false,
      perfis: [],
      setor: '',
      produtividade: [],
      acoes: [ { codigo: 'ANALISE', nome: 'Analisado' }, { codigo: 'VALIDACAO', nome: 'Validação' } ],
      idMunicipios: [],
      municipiosPA: [],
      dadosProdutividade: null,
      activeName: 'tabProdutividade',
      options: {
        shortcuts: [
          {
            text: 'Até Ontem',
            onClick (picker) {
              const end = new Date()
              const start = new Date('2019-1-1')
              end.setDate(end.getDate() - 1)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Últimos 7 dias',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 7))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Últimos 30 dias',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 30))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Este Mês',
            onClick (picker) {
              const end = new Date()
              const start = new Date(end.getUTCFullYear(), end.getMonth(), 1)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Último Mês',
            onClick (picker) {
              let start = new Date()
              let end = new Date()
              if (start.getMonth() === 0) {
                start = new Date(end.getUTCFullYear() - 1, 11, 1)
                end = new Date(end.getUTCFullYear() - 1, 12, 0)
              } else {
                start = new Date(end.getUTCFullYear(), end.getMonth() - 1, 1)
                end = new Date(end.getUTCFullYear(), end.getMonth(), 0)
              }
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Último Ano',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getUTCFullYear() - 1, 0, 1)
              const end = new Date(date.getUTCFullYear() - 1, 12, 0)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate (date) {
          return date > Date.now()
        }
      }
    }
  },

  async created () {
    this.getProdutividade()
  },

  methods: {
    ...mapActions({
      findProdutividade: 'produtividade/findProdutividadeBySetor'
    }),

    async pesquisar () {
      if (this.filtro.dateRange) {
        this.filtro.dataInicio = moment(this.filtro.dateRange[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.filtro.dateRange[1]).format('yyyy-MM-DD')
      }

      this.getProdutividade()
    },

    async getProdutividade () {
      this.isLoading = true
      this.produtividade = await this.findProdutividade(this.filtro)
      this.isLoading = false
    },

    voltar () {
      this.$router.push({
        name: 'produtividade'
      })
    },

    produtividadePorSetor (nome, idsServidores) {
      this.filtro.setor = nome
      this.filtro.setores = [nome]
      this.filtro.idsServidores = idsServidores
      this.$router.push({
        name: 'produtividade/setor',
        params: {
          setor: this.filtro.setor
        }
      })
    },

    limparPesquisa () {
      this.filtro = {
        pagina: 0,
        dateRange: null,
        dataInicio: null,
        setores: [],
        dataFim: null
      }

      this.getProdutividade()
    }
  },

  computed: {

    titulo () {
      return `Sala de Situação`
    },

    api () {
      if (process.env.NODE_ENV === 'development') {
        return 'api/'
      }
      return ''
    },

    hasDados () {
      return (this.produtividade.produtividadeSetores && this.produtividade.produtividadeSetores.length)
    }

  }
}
</script>
<style lang="scss" scoped>

  .pesquisa {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .container-map {
    position: relative;
    padding: 2% 0%;
  }

  #map {
    height: 70vh;
    z-index: 1;
    border-radius: 12px;
  }

  .titulo {
    color: #e5f137;
    font-weight: bold;
    font-size: 20px;
    margin-top: 0px;
  }

  .margin {
    margin-top: 20px;
  }

  .full-width {
    width: 100%;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }

  .div-total {
    padding: 2% 0 0 2%;
    font-size: 14px;
  }

  .box-card {
    margin: 10px 0;
    border-radius: 12px;
  }

  .setor {
    padding: 2% 11% 2% 11%
  }
  .button-pesquisar {
    display: flex;
    justify-content: space-between;
    margin-top: 2%;
  }

  .cinza {
    color: #c0c4cc;
  }

  .flex {
    display: flex;
    justify-content: center;
  }

  .border-top-bottom {
    padding-left: 20vw;
    padding-right: 20vw;
    padding-top: 25px;
    padding-bottom: 25px;
    border-top: solid 1px #c0c4cc;
    border-bottom: solid 1px #c0c4cc;
  }

  @media only screen and (max-width: 1500px) {
    .width-100.el-col {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/produtividade/rr/Home.vue